import AutoAwesomeOutlined from "@mui/icons-material/AutoAwesomeOutlined";
import EditOutlined from "@mui/icons-material/EditOutlined";
import i18n from "../../../../utils/i18n";
import classes from "./commonFillingMethod.module.scss";

const Radio = ({ checked }) => (
  <span
    className={`${classes.radio} ${checked ? classes.radioChecked : ""}`}
    aria-hidden="true"
  />
);

const FILLING_OPTIONS = [
  {
    value: "auto",
    title: i18n.t("searchflow.fillingautotitle"),
    duration: i18n.t("searchflow.fillingautoduration"),
    description: i18n.t("searchflow.fillingautodesc"),
    Icon: AutoAwesomeOutlined,
    iconClassName: classes.iconAuto,
    recommended: true,
  },
  {
    value: "manual",
    title: i18n.t("searchflow.fillingmanualtitle"),
    duration: i18n.t("searchflow.fillingmanualduration"),
    description: i18n.t("searchflow.fillingmanualdesc"),
    Icon: EditOutlined,
    iconClassName: classes.iconManual,
    recommended: false,
  },
];

const CommonFillingMethod = ({
  fillingMethodSelection = "auto",
  onFillingMethodChange,
}) => {
  return (
    <div className={classes.root}>
      <div className={classes.scrollArea}>
        <div className={classes.content}>
          <div className={classes.mainColumn}>
            <header className={classes.header}>
              <h1 className={classes.title}>{i18n.t("searchflow.fillingtitle")}</h1>
              <p className={classes.subtitle}>
                {i18n.t("searchflow.fillingsubtitle")}
              </p>
            </header>

            <div className={classes.rightColumn}>
              <div className={classes.cardsContainer}>
                {FILLING_OPTIONS.map((option) => {
                  const isSelected = fillingMethodSelection === option.value;
                  const { Icon } = option;

                  return (
                    <button
                      key={option.value}
                      type="button"
                      className={`${classes.card} ${isSelected ? classes.selectedRow : ""}`}
                      onClick={() => onFillingMethodChange(option.value)}
                      aria-pressed={isSelected}
                    >
                      {option.recommended && (
                        <span className={classes.recommendedBadge}>
                          {i18n.t("searchflow.fillingfasterbadge")}
                        </span>
                      )}

                      <div className={classes.cardInner}>
                        <div className={classes.cardHeader}>
                          <div
                            className={`${classes.iconCircle} ${option.iconClassName}`}
                          >
                            <Icon className={classes.cardIcon} aria-hidden="true" />
                          </div>
                          <div className={classes.cardHeaderText}>
                            <div className={classes.cardTitle}>{option.title}</div>
                            <div className={classes.cardDuration}>
                              {option.duration}
                            </div>
                          </div>
                          <Radio checked={isSelected} />
                        </div>

                        <div className={classes.cardDivider} aria-hidden="true" />

                        <p className={classes.cardDescription}>{option.description}</p>
                      </div>
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommonFillingMethod;
